import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection, APP_INITIALIZER, PLATFORM_ID } from '@angular/core';

// Other module imports
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { rootReducer } from './modals';
import { AuthenticationEffects } from './modals/Authentication/authentication.effects';
import { routes } from './app.routes';
import { provideRouter, Router } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { CustomToastComponent } from './shared/custom-toast/custom-toast.component';
import { DatePipe } from '@angular/common';
import { PaymentsRecordEffects } from './modals/Payment/payment.effect';
import { isPlatformBrowser } from '@angular/common';
import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';
import { DossiersRecordEffects } from './modals/Dossier/dossier.effect';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'fetch-lang/leden_', '.json');
}

export function provideSentryStandalone(platformId: object) {
  // Prevent Sentry browser integrations from running on SSR/server
  if (!isPlatformBrowser(platformId)) return [];

  // Optional: only wire providers when Sentry is enabled
  if (environment.env === "local") return [];

  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ];
}

export const appConfig: ApplicationConfig = {
  
  providers: [
    DatePipe,
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideStore(rootReducer),
    provideEffects(
      [
        AuthenticationEffects,
        PaymentsRecordEffects,
        DossiersRecordEffects
      ]
    ),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      }),
      ToastrModule.forRoot({
        toastComponent: CustomToastComponent
      }),
    ),
    provideAnimations(),
    { provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } },
    {
      provide: 'SENTRY_PROVIDERS',
      useFactory: provideSentryStandalone,
      deps: [PLATFORM_ID],
    },
  ]
};

